import { TaskAlt as TaskAltIcon } from 'components/icons';
import { Alert } from 'components/ui/alert';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';

interface Props {
    currency: string;
    className?: string;
}

const PaymentCurrencyNotice = ({ currency, className }: Props) => (
    <Alert
        className={cn(
            'border-success/40 bg-grey-50 text-fg flex items-center gap-2 rounded-md border-2 py-2 pr-4 pl-3 text-sm leading-[1.125rem] font-semibold',
            'new:bg-success-tint new:text-foreground new:gap-2.5 new:rounded-lg new:border new:border-transparent new:px-4 new:py-3 new:font-medium',
            className
        )}
    >
        <span className="flex w-6 shrink-0 justify-center [&>svg]:size-4">
            <TaskAltIcon className="text-success/80" />
        </span>
        <div className="min-w-0">
            <FormattedMessage
                id="invoices.payment-currency-mode-notice"
                defaultMessage="Amounts are displayed and edited in {currency} (payment currency)"
                values={{ currency }}
            />
        </div>
    </Alert>
);

export default PaymentCurrencyNotice;
